export const getVyEnv = () => window.__vyEnv || "unknown";

export const getDatadogConfig = () => {
  const config = window.__datadogConfig;
  const { applicationId, clientToken, service } = config ?? {};

  if (!applicationId || !clientToken || !service) {
    return null;
  }

  return { applicationId, clientToken, service };
};

export const getAnonymousUserId = () => {
  const ANPNYMOUS_USER_ID_LOCAL_STORAGE_KEY = "anonymousUserId";
  const storedAnonymousUserId = window.localStorage.getItem(
    ANPNYMOUS_USER_ID_LOCAL_STORAGE_KEY,
  );

  if (storedAnonymousUserId) {
    return storedAnonymousUserId;
  }

  const newAnonymousUserId = window.crypto.randomUUID();
  window.localStorage.setItem(
    ANPNYMOUS_USER_ID_LOCAL_STORAGE_KEY,
    newAnonymousUserId,
  );
  return newAnonymousUserId;
};
